export default __webpack_public_path__ + "static/peachNotePeach-a85535d5b0a0ad3bb74a10564b2000c3.png";